import URLS from './URLS';
import axios from '__js__/axios';
import reverse from 'django-reverse';
import { AxiosResponse } from 'axios';
import { vm } from './../../../../';

export default (mapTranslateId: string): Promise<AxiosResponse<any>> => {
	return axios.delete(reverse(URLS.DELETE_MAP_TRANSLATE, vm.$store.state.language, mapTranslateId));
};
